import React from 'react';
import { msToTime } from '../../utils';
import moment from 'moment';

const DiagUrgentColumn = ({ data}) => {
    let color = '#000000';
    let createdAtLabel = '';
    let dueDateLabel = '';
    let days = ''
    if(data.urgent_todo_create_ts){
        createdAtLabel = moment(data.urgent_todo_create_ts).format('MMMM DD, YYYY')
        dueDateLabel = moment(data.urgent_todo_due_date).format('MMMM DD, YYYY')
        days = moment().diff(moment(data.urgent_todo_create_ts), 'days');
    }
  

    if(moment().isAfter(moment(data.urgent_todo_due_date))){
        color = 'red';
    }
    if(data.urgent_todo_create_ts){
        return (
                <div>
                    <div>
                            Created: {createdAtLabel}
                    </div>
                    <div style={{color:color}}> 
                            Due: {dueDateLabel}
                    </div>
                    <div>
                            Days Open: {days}
                    </div>
                </div>
        );
    }
    return <div/>;
    
};

export default DiagUrgentColumn;
